import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import deviceSelect from '@blade/common/components/device-cascader-select/index.vue';
import DataResult from '@blade-sxp/data-mining/pages/companions/components/result/index.vue';
import DetailsPage from '@blade/common/pages/result-details/index.vue';
import { getDetail, searchByObjectId } from '@blade-sxp/data-mining/apis/index';
import moment from 'moment';
let AlarmCenter = class AlarmCenter extends Vue {
    allNum = 10;
    pageSize = {
        page: 1,
        total: 0,
    };
    form = {
        dates: [],
        device: [],
    };
    isOpenDetail = false;
    routeType = 'bigData';
    url = '';
    detailsData = [];
    tagList = []; // 吸顶后的数据
    isRoute = false;
    labelList = [];
    timeAhead = '';
    laterTime = '';
    deviceIds = [];
    imgList = [];
    // hover框轨迹数据
    selectedImg = [];
    currentIndex = 0;
    maxNum = 50;
    minNum = 0;
    defaultTime = ['00:00:00', '23:59:59'];
    isWidth = true;
    loading = false;
    get pickerResult() {
        return {
            disabledDate(time) {
                return moment(time).subtract(1, 'days').isSameOrAfter(moment().format('YYYY-MM-DD'));
            },
        };
    }
    mounted() {
        const data = JSON.parse(this.$route.query.param);
        const { dateEnd, dateStart, deviceId } = data;
        this.$set(this.form.dates, 1, dateEnd);
        this.$set(this.form.dates, 0, dateStart);
        this.form.device = deviceId;
        this.initData();
        window.addEventListener('scroll', this.handleScrollx, true);
    }
    handleScrollx(e) {
        const elm = e.target;
        if (elm?.className === 'main-container') {
            this.$refs.datePicker.pickerVisible = false;
            this.$refs.cascader.$children[0].$children[0].dropDownVisible = false;
        }
    }
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScrollx, true);
    }
    initData() {
        const data = this.$route.query;
        const dataParam = JSON.parse(data.param);
        const { documentTaskId, companionsCount, gapSecond, documentId } = dataParam;
        const { companionEntityId } = data;
        let documentTaskIds = documentTaskId;
        if (!this.form.device?.length && !documentTaskIds?.length) {
            return;
        }
        if (this.form.device?.length) {
            documentTaskIds = [];
        }
        else {
            documentTaskIds = documentTaskId;
        }
        this.loading = true;
        const param = {
            documentId: documentId,
            companionEntityId: companionEntityId,
            documentTaskId: documentTaskIds ?? [],
            companionsCount: companionsCount,
            gapSecond: gapSecond,
            size: 72,
            page: this.pageSize.page,
            dateEnd: this.form.dates?.[1],
            dateStart: this.form.dates?.[0],
            deviceId: this.form.device ?? [],
        };
        getDetail(param).then((res) => {
            this.imgList = res.list;
            this.pageSize = {
                page: res.page,
                total: res.total,
            };
            this.loading = false;
        });
        this.labelList = this.form.device;
        this.tagData();
    }
    // 改变时间
    pickerOptions(time) {
        this.form.dates = time;
        // const newTime = time ?? [];
        // // this.tagList = newTime;
        // debugger;
        // this.tagList.push(String(newTime));
        this.pageSize.page = 1;
        this.initData();
    }
    changePageSize(page) {
        // console.log(page, '当前页');
        this.pageSize.page = page;
        this.initData();
    }
    // 清空全部轨迹
    clearAlltrack() {
        // console.log('清空hover弹框全部轨迹');
    }
    showPopover() {
        // console.log('触发hover弹框');
    }
    // 删除一个轨迹
    deleteImg(imageId) {
        // console.log('删除一个轨迹');
    }
    // 选中/删除轨迹
    changeTrack(val, deviceVal, index) {
        // console.log(val, deviceVal, index, '选中轨迹');
    }
    deviceIdRest(val) {
        this.form.device = val;
        this.pageSize.page = 1;
        this.initData();
    }
    onLabelChange(val) {
        if (val.length === 1 && this.labelList[0] === val[0].label) {
            this.labelList = [];
            return;
        }
        this.labelList = [];
        val.forEach((item) => {
            this.labelList.push(item.label);
        });
        this.tagData();
    }
    tagData() {
        this.tagList = [];
        if (!this.labelList) {
            this.labelList = [];
        }
        if (this.labelList.length > 1) {
            this.labelList = [`${this.$t('multiple')}`];
        }
        if (this.form.dates?.[0] !== '') {
            if (!this.form.dates) {
                this.form.dates = [];
            }
            this.tagList.push(String(this.form.dates), String(this.labelList));
        }
    }
    openDetail(data, index) {
        this.detailData(data);
        this.currentIndex = index;
    }
    detailData(data) {
        const param = {
            objectId: data.objectId,
            // objectId: '14660033-1de4-11ed-e939-000309007723',
            objectType: 'OBJECT_FACE',
            deviceId: data.deviceId,
        };
        searchByObjectId(param).then((res) => {
            this.detailsData = res[data.objectId];
            this.detailsData.deviceId = data.deviceId;
            this.detailsData.deviceName = data.deviceName;
            this.detailsData.captureTime = moment(Number(this.detailsData.captureTime)).format('YYYY-MM-DD HH:mm:ss');
            this.detailsData.objectType = 'OBJECT_FACE';
            this.isOpenDetail = true;
        });
    }
    next() {
        if (this.currentIndex === this.maxNum) {
            this.currentIndex = this.maxNum;
        }
        else {
            this.currentIndex++;
        }
        const data = this.imgList[this.currentIndex];
        this.detailData(data);
    }
    prev() {
        if (this.currentIndex === this.minNum) {
            this.currentIndex = this.minNum;
        }
        else {
            this.currentIndex--;
        }
        const data = this.imgList[this.currentIndex];
        this.detailData(data);
    }
    reset() {
        const data = this.$route.query;
        const { dateEnd, dateStart, deviceId } = data;
        this.$set(this.form.dates, 1, dateEnd);
        this.$set(this.form.dates, 0, dateStart);
        this.form.device = deviceId;
        this.pageSize.page = 1;
        this.initData();
    }
    closeDetails() {
        this.isOpenDetail = false;
        // console.log('关闭详情弹框');
    }
    openTrack() {
        // console.log('打开轨迹弹框');
    }
};
AlarmCenter = __decorate([
    Component({
        name: 'SearchFrom',
        components: { DataResult, deviceSelect, DetailsPage },
        i18n: {
            messages: {
                en: {
                    reset: 'Reset',
                    device: 'Device',
                    startTime: 'Start',
                    endTime: 'End',
                    multiple: 'Multiple Devices',
                },
                zh: {
                    reset: '重置',
                    device: '设备',
                    multiple: '多个设备',
                    startTime: '开始',
                    endTime: '结束',
                },
            },
        },
    })
], AlarmCenter);
export default AlarmCenter;
